import { render } from "./CookieCalculator.vue?vue&type=template&id=cdbb6466"
import script from "./CookieCalculator.vue?vue&type=script&lang=js"
export * from "./CookieCalculator.vue?vue&type=script&lang=js"

import "./CookieCalculator.vue?vue&type=style&index=0&id=cdbb6466&lang=css"
script.render = render

export default script